import axios from "@/api/config";

const user = {
  getUserById(data) {
    return axios.get(`${process.env.BASE_URL}/user/getUser/` + data, {});
  },
  getUser(data) {
    return axios.get(`${process.env.BASE_URL}/user/getUser`, { params: data });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/user/pageList`, data);
  },
  addUser(data) {
    return axios.post(`${process.env.BASE_URL}/user/addUser`, data);
  },
  updateUser(data) {
    return axios.put(`${process.env.BASE_URL}/user/updateUser`, data);
  },
  deleteUser(data) {
    return axios.delete(`${process.env.BASE_URL}/user/deleteUser`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/user/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/user/importData`, data);
  },
  changeSubject(data) {
    return axios.put(`${process.env.BASE_URL}/user/changeSubject`, data);
  },
  //弹框通知
  getNewestNotice(data) {
    return axios.get(`${process.env.BASE_URL}/notice/getNewestNotice`, {
      params: data
    });
  },
  //通知详情
  getNotice(data) {
    return axios.get(`${process.env.BASE_URL}/notice/getNotice`, {
      params: data
    });
  },

  //    全部标记为已读
  noticeAllRead(data) {
    return axios.post(`${process.env.BASE_URL}/notice/noticeAllRead`, data);
  },

  //    通知列表
  getNoticeList(data) {
    return axios.get(`${process.env.BASE_URL}/notice/getNoticeList`, {
      params: data
    });
  },

  // 通知列表3.0
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/notice/pageList`, data);
  },

  //    通知列表
  getAgentNotice(data) {
    return axios.get(`${process.env.BASE_URL}/notice/getAgentNotice`, {
      params: data
    });
  },
  //按钮权限
  getButtonRoleResourceList(data) {
    return axios.get(
      `${process.env.BASE_URL}/system/getAgentButtonRoleResourceList`,
      { params: data }
    );
  },
  getToken() {
    return axios.get(`${process.env.BASE_URL}/dashboard/getToken`);
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/api/user.js